<template>
  <div class="user-manage">
    <div class="form-container">
      <div class="flex">
        <el-input class="gray" clearable v-model="form.username" placeholder="请输入姓名"></el-input>
        <el-button class="btn-blue" @click="searchList">搜索</el-button>
      </div>
      <el-button class="btn-blue" @click="openDialog">新增</el-button>
    </div>
    <div class="table-container">
      <div class="table">
        <el-table :data="userList" style="width: 100%">
          <el-table-column prop="name" label="姓名"></el-table-column>
          <el-table-column prop="username" label="用户名"></el-table-column>
          <el-table-column prop="code" label="客服人员代码"></el-table-column>
          <el-table-column prop="eccDepartmentName" label="部门"></el-table-column>
          <el-table-column prop="status" label="是否启用">
            <template slot-scope="scope">
              <el-switch
                @change="updateStatus($event,scope.row.id)"
                v-model="scope.row.status"
                active-color="#2e68ea"
                inactive-color="#D5D5D6"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="100">
            <template slot-scope="scope">
              <el-button
                :disabled="scope.row.status===0"
                class="btn-text"
                type="text"
                @click="updateUser(scope.row)"
              >编辑</el-button>
              <el-button
                :disabled="scope.row.status===0"
                class="btn-text"
                type="text"
                @click="toUserAuthority(scope.row.id,scope.row.name)"
              >权限设置</el-button>
              <el-button
                :disabled="scope.row.status===0"
                class="btn-text"
                type="text"
                @click="setDepartment(scope.row.id)"
              >易仓储权限设置</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog :title="dialogTitle" top="35vh" :visible.sync="userDialog" width="380px">
      <div class="border"></div>
      <el-form ref="userForm" :rules="userFormRules" :model="userForm" label-width="110px">
        <el-form-item label="姓名：" prop="name">
          <el-input v-model="userForm.name" class="white" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="用户名：" prop="username">
          <el-input v-model="userForm.username" class="white" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="客服人员代码：" prop="code">
          <el-input v-model="userForm.code" class="white" placeholder="请输入客服人员代码"></el-input>
        </el-form-item>
        <el-form-item label="密码：" prop="password">
          <el-input v-model="userForm.password" class="white" type="password" placeholder="请输入密码"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeDialog">取消</el-button>
        <el-button class="btn-blue" @click="submitForm('userForm')">确定</el-button>
      </div>
    </el-dialog>

    
    <!-- 易仓储部门权限 -->
    <el-dialog
      title="易仓储部门权限设置"
      top="26vh"
      :visible.sync="departmentSetDialog"
      width="420px"
      class="department-set"
    >
      <div class="border"></div>
      <el-form
        ref="departmentSetForm"
        :model="departmentSetForm"
      >
        <el-form-item label="部门" prop="departmentId">
          <el-select
            class="white"
            v-model="departmentSetForm.departmentId"
            clearable
            placeholder="请选择">
            <el-option
              v-for="(w, wIndex) in departmentList"
              :key="wIndex"
              :label="w.departmentName"
              :value="w.id"
              >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeDepartmentSetDialog">取消</el-button>
        <el-button class="btn-blue" @click="saveDepartmentSet('departmentSetForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import YCC from "models/ycc";
import UserManage from "models/user-manage";
const userManage = new UserManage();
import YCCMixins from 'common/mixins/ycc'
import { modifyNetTitle } from "common/js/util";
export default {
  mixins: [YCCMixins],
  data() {
    return {
      form: {
        username: ""
      },
      searchForm: {
        username: ""
      },
      userList: [],
      dialogTitle: "新增",
      userDialog: false,
      userForm: {
        id: "",
        name: "",
        username: "",
        code: "",
        password: ""
      },
      userFormRules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" }
        ],
        code: [
          { required: true, message: "请输入客服人员代码", trigger: "blur" }
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },
      
      departmentSetDialog: false,
      departmentSetForm: {
        id: '',
        departmentId: '',
        name: ''
      }
    };
  },
  watch: {
    userDialog: {
      handler(newVal) {
        if (!newVal) {
          this.userForm.id = "";
          this.userForm.name = "";
          this.userForm.username = "";
          this.userForm.code = "";
          this.userForm.password = "";
          this.userFormRules.password[0].required = true;
          this.dialogTitle = "新增";
        }
      }
    }
  },
  async created() {
    modifyNetTitle('用户管理')
    await this.initYCCDepartmentList()
    this.getUserList();
  },
  methods: {
    //获取管理员列表
    async getUserList() {
      let name = this.searchForm.username;
      let res = await userManage.getManagerList(name)
      if (res.success) {
        let userList = [];
        res.result.map(value => {
          let obj = {};
          obj.id = value.id;
          obj.eccDepartmentId = value.eccDepartmentId;
          let departmentObj = this.departmentList.find(item => {return item.id === value.eccDepartmentId})
          obj.eccDepartmentName = departmentObj ? departmentObj.departmentName : ''
          obj.name = value.name;
          obj.username = value.username;
          obj.code = value.code;
          obj.status = value.status;
          userList.push(obj);
        });
        this.userList = userList;
      }
    },
    searchList() {
      this.searchForm = this.form;
      this.getUserList();
    },
    //修改状态
    updateStatus(value, id) {
      let data = {
        id
      };
      userManage.postUpdateManagerStatus(data).then(res => {
        if (res.success) {
          this.getUserList();
        }
      });
    },
    //显示弹窗
    openDialog() {
      this.userDialog = true;
    },
    //关闭弹窗
    closeDialog() {
      this.userDialog = false;
    },
    //编辑
    updateUser(row) {
      this.userDialog = true;
      this.dialogTitle = "编辑";
      this.userForm.id = row.id;
      this.userForm.name = row.name;
      this.userForm.username = row.username;
      this.userForm.code = row.code;
      this.userFormRules.password[0].required = false;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.userForm.id) {
            let data = {};
            data.id = this.userForm.id;
            data.name = this.userForm.name;
            data.username = this.userForm.username;
            data.code = this.userForm.code;
            data.password = this.userForm.password;
            userManage.postUpdateManager(data).then(res => {
              if (res.success) {
                this.getUserList();
                this.closeDialog();
                this.$message.success("编辑成功");
              } else {
                this.$message.error(res.message);
              }
            });
          } else {
            let data = {};
            data.name = this.userForm.name;
            data.username = this.userForm.username;
            data.code = this.userForm.code;
            data.password = this.userForm.password;
            userManage.postAddManager(data).then(res => {
              if (res.success) {
                this.getUserList();
                this.closeDialog();
                this.$message.success("新增成功");
              } else {
                this.$message.error(res.message);
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    toUserAuthority(id, name) {
      this.$router.push(`/system-settings/user-manage/user-authority?id=${id}&name=${name}`);
    },

    setDepartment(id) {
      YCC.postYCCDepartmentAuthDetails(id).then(res => {
        if (res.success) {
          this.departmentSetForm.id = id
          if (res.result) {
            let { id, name } = res.result
            this.departmentSetForm.name = name
            this.departmentSetForm.departmentId = id
          }
          this.departmentSetDialog = true;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    closeDepartmentSetDialog() {
      this.departmentSetForm.id = ''
      this.departmentSetForm.name = ''
      this.departmentSetForm.departmentId = ''
      this.departmentSetDialog = false;
    },
    saveDepartmentSet(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let data = {};
          data.managerId = this.departmentSetForm.id;
          data.eccDepartmentId = this.departmentSetForm.departmentId;
          YCC.postYCCDepartmentAuthUpdate(data).then(res => {
            if (res.success) {
              this.$message.success("修改成功");
              this.getUserList();
              this.closeDepartmentSetDialog();
            } else {
              this.$message.error(res.message);
            }
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.user-manage {
  flex: 1;
  display: flex;
  flex-direction: column;
  .form-container {
    padding: 16px;
    background: #fff;
    margin-bottom: 16px;
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
    .flex {
      display: flex;
      .btn-blue {
        margin-left: 16px;
      }
    }
  }
  .table-container {
    min-height: 500px;
    padding: 16px;
    background: #fff;
    border-radius: 4px;
    .table {
      .is-disabled {
        color: #999999;
      }
    }
  }
  .el-dialog {
    .el-form {
      padding: 0 20px 20px 0px;
      .el-select {
        width: 100%;
      }
    }
    .dialog-footer {
      padding-top: 16px;
      border-top: 1px solid #eeeeee;
      display: flex;
      justify-content: center;
    }
  }
  .department-set {
    .el-form {
      padding: 0 0px 30px 0px;
      .el-select {
        width: 100%;
      }
    }
  }
}
</style>
